import React from 'react';
import { Link } from 'react-router-dom'
import RoleInterface from '../../Helpers/role.interface';
import { useAblContext } from '../../Hooks/useAblContext';


const ProducerMenu: React.FC = () => {

  const abl = useAblContext();


  const setupMenu = () => {
    if(abl.roles === "admin" || abl.roles === "banca") {
      return (
        <li className="dropdown">
        <a className="dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">PRODUTORAS
        </a>
        <ul className="dropdown-menu">
          <li>
            <Link to="/producer" className="user">
              Gerenciar Produtoras
            </Link>
          </li>
        </ul>
      </li>
      )
    }
    return null

  }

  return setupMenu()

}

export default ProducerMenu;
